'use strict';
const generateSvg = require('./generate-svg'),
	contentUpgrade = require('@mindmup/mapjs-core/src/content/content-upgrade');

module.exports = function generateSvgFromExport(mapJson, textEngine, stickersEngine, additionalOptions) {
	const svgOptions = Object.assign({
		scale: (mapJson.export && mapJson.export.scale) || 1,
		padding: 10,
		page: (mapJson.export && mapJson.export.page)
	}, additionalOptions);
	if (mapJson.labels) {
		svgOptions.padding = svgOptions.padding + 20 * svgOptions.scale;
	}
	if (mapJson.theme) {
		mapJson.attr = Object.assign({}, mapJson.attr, {theme: mapJson.theme});
	}
	return generateSvg(contentUpgrade(mapJson), textEngine, stickersEngine, svgOptions);
};
